(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      if (entry.target.classList.contains('mm-fade')) {
        entry.target.classList.add('is-visible');
      } else {
        entry.target.classList.add('mm-revealed');
      }
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function prepare(root) {
    var scope = root || document;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    scope.querySelectorAll('.mm-fade:not([data-mm-reveal-bound])').forEach(function (element) {
      element.setAttribute('data-mm-reveal-bound', '');
      if (element.closest('.lp') || element.getBoundingClientRect().top < viewportHeight * 0.9) {
        element.classList.add('is-visible');
        return;
      }
      observer.observe(element);
    });

    var main = scope.id === 'MainContent' ? scope : scope.querySelector('#MainContent');
    if (!main) return;

    main.querySelectorAll(':scope > .shopify-section:not([data-mm-reveal-bound])').forEach(function (section, index) {
      section.setAttribute('data-mm-reveal-bound', '');
      if (
        index === 0 ||
        section.hasAttribute('data-mm-no-reveal') ||
        section.querySelector('.mm-fade, .ga-fade, .ga2-fade, .ga3-fade, .lp-fade') ||
        section.getBoundingClientRect().top < viewportHeight * 0.9
      ) {
        return;
      }
      section.classList.add('mm-reveal-init');
      observer.observe(section);
    });
  }

  function init() {
    prepare(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    prepare(event.target);
  });
})();
